import {
  COMMUNITY_TAG_ACTION_START,
  COMMUNITY_TAG_ACTION_ERROR,
  GET_ALL_COMMUNITY_TAGS,
  CREATE_COMMUNITY_TAG,
  DELETE_COMMUNITY_TAG,
} from './actions';

const initialState = {
  loading: false,
  error: null,
  communityTags: [],
};

const communityTagReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case COMMUNITY_TAG_ACTION_START:
      return { ...state, loading: true, error: null };
    case COMMUNITY_TAG_ACTION_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_ALL_COMMUNITY_TAGS:
      return { ...state, loading: false, communityTags: action.payload };
    case CREATE_COMMUNITY_TAG:
      return {
        ...state,
        loading: false,
        communityTags: [...state.communityTags, action.payload],
      };
    case DELETE_COMMUNITY_TAG:
      return {
        ...state,
        loading: false,
        communityTags: state.communityTags.filter(
          (tag: any) => tag.id !== action.payload,
        ),
      };
    default:
      return state;
  }
};

export default communityTagReducer;

